"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSIClient = void 0;
const actions_1 = require("./actions");
const defaultIntegrations_1 = require("./defaultIntegrations");
const integrationConfiguration_1 = require("./integrationConfiguration");
const transmissionConfigurations_1 = require("./transmissionConfigurations");
const transmissionMethods_1 = require("./transmissionMethods");
const getSIClient = ({ accessToken, env, options: globalOptions }) => {
    return {
        getActionTypeForKey: async (key) => {
            return (0, actions_1.getActionTypeForKey)(accessToken, key, env, globalOptions);
        },
        getActionTypes: async () => {
            return (0, actions_1.getActionTypes)(accessToken, env, globalOptions);
        },
        getTransmissionMethodForKey: async (key) => {
            return (0, transmissionMethods_1.getTransmissionMethodForKey)(accessToken, key, env, globalOptions);
        },
        getTransmissionMethods: async () => {
            return (0, transmissionMethods_1.getTransmissionMethods)(accessToken, env, globalOptions);
        },
        getDefaultIntegrations: async (accountUrl, fulfillerUrl, fulfillmentLocationUrl, options) => {
            return (0, defaultIntegrations_1.getDefaultIntegrations)(accessToken, accountUrl, fulfillerUrl, fulfillmentLocationUrl, Object.assign(Object.assign({}, globalOptions), options), env);
        },
        getDefaultIntegrationById: async (id) => {
            return (0, defaultIntegrations_1.getDefaultIntegrationById)(accessToken, id, env, globalOptions);
        },
        getDefaultIntegrationByUrl: async (url) => {
            return (0, defaultIntegrations_1.getDefaultIntegrationByUrl)(accessToken, url, globalOptions);
        },
        postDefaultIntegrations: async (req) => {
            return (0, defaultIntegrations_1.postDefaultIntegrations)(accessToken, req, env, globalOptions);
        },
        putDefaultIntegrationById: async (id, defaultIc) => {
            return (0, defaultIntegrations_1.putDefaultIntegrationById)(accessToken, id, defaultIc, env, globalOptions);
        },
        getIntegrationConfigurations: async (options) => {
            return (0, integrationConfiguration_1.getIntegrationConfigurations)(accessToken, Object.assign(Object.assign({}, globalOptions), options), env);
        },
        getIntegrationConfigurationById: async (id) => {
            return (0, integrationConfiguration_1.getIntegrationConfigurationById)(accessToken, id, env, globalOptions);
        },
        getIntegrationConfigurationByUrl: async (url) => {
            return (0, integrationConfiguration_1.getIntegrationConfigurationByUrl)(accessToken, url, globalOptions);
        },
        getIntegrationConfigurationVersionsById: async (id, options) => {
            return (0, integrationConfiguration_1.getIntegrationConfigurationVersionsById)(accessToken, id, Object.assign(Object.assign({}, globalOptions), options), env);
        },
        getIntegrationConfigurationVersionsByUrl: async (url, options) => {
            return (0, integrationConfiguration_1.getIntegrationConfigurationVersionsByUrl)(accessToken, url, Object.assign(Object.assign({}, globalOptions), options));
        },
        postIntegrationConfiguration: async (ic) => {
            return (0, integrationConfiguration_1.postIntegrationConfiguration)(accessToken, ic, env, globalOptions);
        },
        patchIntegrationConfiguration: async (patchDocument, integrationConfigurationId) => {
            return (0, integrationConfiguration_1.patchIntegrationConfiguration)(accessToken, patchDocument, integrationConfigurationId, env, globalOptions);
        },
        orchestrateIntegrationConfiguration: async (accessToken, orchestrateRequest) => {
            return (0, integrationConfiguration_1.orchestrateIntegrationConfiguration)(accessToken, orchestrateRequest, env, globalOptions);
        },
        getTransmissionConfigurationById: async (id) => {
            return (0, transmissionConfigurations_1.getTransmissionConfigurationById)(accessToken, id, env, globalOptions);
        },
        getTransmissionConfigurationByUrl: async (url) => {
            return (0, transmissionConfigurations_1.getTransmissionConfigurationByUrl)(accessToken, url, globalOptions);
        },
        getTransmissionConfigurationByIdAndVersion: async (id, version) => {
            return (0, transmissionConfigurations_1.getTransmissionConfigurationByIdAndVersion)(accessToken, id, version, env, globalOptions);
        },
        getTransmissionConfigurationVersionsById: async (id, options) => {
            return (0, transmissionConfigurations_1.getTransmissionConfigurationVersionsById)(accessToken, id, Object.assign(Object.assign({}, globalOptions), options), env);
        },
        getTransmissionConfigurationVersionsByUrl: async (url, options) => {
            return (0, transmissionConfigurations_1.getTransmissionConfigurationVersionsByUrl)(accessToken, url, Object.assign(Object.assign({}, globalOptions), options));
        },
        postTransmissionConfiguration: async (tc) => {
            return (0, transmissionConfigurations_1.postTransmissionConfiguration)(accessToken, tc, env, globalOptions);
        },
        getTransmissionConfigurations: async (options) => {
            return (0, transmissionConfigurations_1.getTransmissionConfigurations)(accessToken, Object.assign(Object.assign({}, globalOptions), options), env);
        },
        putTransmissionConfiguration: async (id, tc) => {
            return (0, transmissionConfigurations_1.putTransmissionConfiguration)(accessToken, id, tc, env, globalOptions);
        },
    };
};
exports.getSIClient = getSIClient;
